/**
 * TanStack Query hooks for `regional-support`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	regionalSupportQueryKeys,
	type CreateRegionalSupportBody,
	type ListRegionalSupportResponse,
	type RegionalSupportRow,
} from "./api";

export function useRegionalSupportList(): UseQueryResult<ListRegionalSupportResponse, Error> {
	return useQuery({
		queryKey: regionalSupportQueryKeys.list(),
		queryFn: list,
	});
}

export function useRegionalSupportCreate(): UseMutationResult<RegionalSupportRow, Error, CreateRegionalSupportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalSupportQueryKeys.all });
		},
	});
}

export function useRegionalSupportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalSupportQueryKeys.all });
		},
	});
}
